import { ErrorComponent } from "@components/ErrorComponent";
import { Loader } from "@components/Loader";
import { MainLayout, MainLayoutProps } from "@components/MainLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { useUser } from "@hooks";
import { i18n, Translations } from "@i18n";
import { calculateCardProjections } from "@utils";
import { EmptyCard } from "./EmptyCard";
import { ProgressCard } from "./ProgressCard";
import { CaptionText } from "./styles";

export const AccountsRoute = () => {
  const { beneficiaries, loading, error } = useUser();

  const props: MainLayoutProps = {
    showTab: true,
  };

  if (loading) return <Loader />;
  if (error) return <ErrorComponent />;

  const cardProjections = calculateCardProjections({
    beneficiaries,
  });

  return (
    <MainLayout {...props}>
      <CaptionText>{i18n.t(Translations.AccountsRouteTitle)}</CaptionText>
      <Spacing size={SpacingSizes.M} />

      {cardProjections.map((card, index) => (
        <ProgressCard key={`progress-card-${index}`} {...card} />
      ))}

      <EmptyCard />
    </MainLayout>
  );
};
